import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  borderRadius = tokens.borderRadius,
  spacing = tokens.spacing;
var bodyBold = designTokenFonts.bodyBold,
  mini = designTokenFonts.mini;
export var container = /*#__PURE__*/css("display:flex;flex-direction:column;justify-content:space-between;gap:", spacing.xs, ";width:230px;background-color:", colors.neutral.surface.default, ";border:1px solid ", colors.neutral.trim.default, ";border-radius:", borderRadius.inner, ";padding:calc(", spacing.s, " - ", spacing.xxs, ");overflow:hidden;flex-shrink:0;cursor:pointer;");
export var logo = /*#__PURE__*/css("max-width:120px;height:42px;flex-shrink:0;border-radius:", borderRadius.mini, ";");
export var agent = /*#__PURE__*/css("display:flex;flex-direction:row;gap:", spacing.xs, ";overflow:hidden;");
export var avatar = {
  name: "12nlyhb",
  styles: "flex-shrink:0;width:50px;height:50px;"
};
export var nameTitle = {
  name: "i6bazn",
  styles: "overflow:hidden;"
};
export var agentName = /*#__PURE__*/css("display:-webkit-box;", bodyBold, ";color:", colors.neutral.heavy.default, ";overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;-webkit-box-orient:vertical;");
export var jobTitle = /*#__PURE__*/css(mini, ";color:", colors.neutral.medium.default, ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;");
export var bottom = {
  name: "u4p24i",
  styles: "display:flex;flex-direction:row;align-items:center;"
};
export var nameAddress = {
  name: "i6bazn",
  styles: "overflow:hidden;"
};
export var agencyName = /*#__PURE__*/css(bodyBold, ";color:", colors.neutral.heavy.default, ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;");
export var address = /*#__PURE__*/css(mini, ";color:", colors.neutral.medium.default, ";");
export var reviews = /*#__PURE__*/css();